import { Component } from "react";
import Article from "../../../Article/Article";

export default class Feb232023 extends Component {
  render() {
    return (
      <Article title="February 25, 2023">
        <h3>Hello Again!</h3>
        <p>
          So I decided to update this page. It's been 2 years since I started
          it! I had originally planned on using it as a tool to a) learn ReactJS
          and b) learn new things by explaining them 'simply', as done in my
          post on <a href="/binomial">Pascal's Triangle</a>. Since that first
          post though, I just haven't come across anything that I felt justified
          a write up. I never intended for this to be a personal, 'diary' type
          blog. But I've got nothing else to write about at the moment, and I
          feel like I should get in the habit of writing some more. A big part
          of why I'm writing this is because I enjoy reading blogs so much. I
          appreciate that people take the time to build these things and share a
          little slice of their lives. It's much more interesting to me than
          using one of the social media sites. Updating this page took a bit of
          refreshing (pun intended) some dusty skills. It didn't take me long to
          remember how to write react. I added{" "}
          <a href="https://reactrouter.com/en/main">react-router</a>, tweaked
          the header a little bit, and had to fix my heroku pipeline.
        </p>
        <h3>What have I been up to?</h3>
        <p>
          Since the new year I haven't done much in terms of programming
          projects. I did write a little application to track our household
          budget. The frontend was done in&nbsp;
          <a href="https://kit.svelte.dev/">Svelte(kit)</a>, and the backend was
          done with <a href="https://expressjs.com/">node+express</a> and an
          sqlite database. I also used a CSS framework called Bulma. I did enjoy
          working with Svelte, and writing a simple express API that tied into
          sqlite was a lot of fun as well. I think the Svelte concept (that is,
          'compiling' your code to HTML/CSS/JS) makes more sense than using a
          library (i.e. react). It's also a little more intuitive to write. I
          haven't decided yet if I should 'convert' this page to one using
          Svelte. Honestly, it's not as if this one 'needs' react anyways.
        </p>
        <h3>A ChatGPT Inspired Mid-Life Crisis?</h3>
        <p>
          I'm feeling a little anxious, and I am 42. Does that make it a
          mid-life crisis? A good chunk of this anxiety came about when I
          started playing with ChatGPT. A couple of years ago, Elon Musk was
          talking about how sociey will need something like a universal basic
          income, because AI is further advanced than everyone realizes and it
          will eliminate the need for many jobs. Now we see what he saw. Am I
          going to be able to ride this career out 20 more years until I can
          retire? I have my doubts.
        </p>
        <h3>Interesting Finds of Late</h3>
        <h4>
          <a href="https://www.jsanilac.com/mind/">
            https://www.jsanilac.com/mind/
          </a>
        </h4>
        <p>
          I found this little blog (as with most of my finds) from Hacker News.
          Not only do I tend to agree wholeheartedly with this particular take
          on the so-called 'mind-body' problem, but I just <em>love</em> the
          idiosyncracies of this site, from the unqiue style to the music that
          the author has published. To me, this is a great example of a personal
          blog.{" "}
        </p>
        <h4>
          <a href="https://www.diegovera.org/projects">
            https://www.diegovera.org/projects
          </a>
        </h4>
        <p>
          This guy's self-study list is enviable and inspirational. I'd love to
          do something like this, but I haven't been able to find the time (or
          the discipline, rather). I have a lot of courses and books that I've
          started and failed to finish. Unfortunately I easily grow bored with a
          topic and decide to dive into something else. One of my goals is to
          finish more of the things I start.{" "}
        </p>
        <h4>
          <a href="https://vimium.github.io/">Vimium</a>
        </h4>
        <p>
          This browser extension is incredible. I happen to use the Firefox
          version of this extension (using a Google browser creeps me out). The
          VIM keybindings are the most useful thing I've learned over the last
          couple of years. I've added VIM extensions now to most of the tools I
          use (VS Code, Intellij, and now my browser). This extension is so well
          done!
        </p>
        <h3>Learnings of Late</h3>
        <p>
          As alluded to above, I'm always learning something, even if the
          majority of those topics are abandoned midway. Currently, I'm going
          through the (in)famous{" "}
          <a href="https://sarabander.github.io/sicp/html/">SICP</a>. There was
          some talk on Hacker News recently because such-and-such college was
          dropping SICP from their curriculum. The comments on there were split
          between those who considered a waste of time and those who consider it
          essential. I'm only midway through Chapter 1, but so far it's been
          pleasant. I've been going through the exercises with{" "}
          <a href="https://racket-lang.org/">Racket</a> and an available SICP
          language extension. Funny enough, I've just gotten to an exercise
          involving Pascal's Triangle. Maybe, if I stick with it, I'll get
          inspired to write another cool 'topic' page.{" "}
        </p>
        <h3>Family!</h3>
        <p>
          Last, but not least, I should mention the primary focus of my life, my
          family. Everyone is doing great! My wife just started a new job; her
          first time being a "boss". I'm excited for her and she seems to enjoy
          this new challenge. My oldest (21) is pursuing an electrician career.
          Im excited for him and hope he can parlay some of the knowledge he
          learns here with his love of music making. It seems to me there is a
          strong overlap between the two. The next kid down (19) is currently on
          an academic scholarship, pursuing an environmental engineering degree.
          I happen to have the same degree! Hopefully she will actually use
          hers. The last one (4) is growing up too fast! He's growing and
          changing everyday. We should all aspire for the same!{" "}
        </p>
      </Article>
    );
  }
}
